import React, { useEffect, useState } from 'react';
import { TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

interface SearchboxProps {
  placeholder?: string;
  onSearch?: (searchTerm: string) => void;
}

const Searchbox: React.FC<SearchboxProps> = ({ onSearch, placeholder }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedValue, setDebouncedValue] = useState('');

  // Debounce effect
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchTerm);
    }, 500); // delay in ms

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  // Call parent callback when debounced value changes
  useEffect(() => {
    if (onSearch) {
      onSearch(debouncedValue);
    }
  }, [debouncedValue, onSearch]);

  return (
    <TextField
      variant="filled"
      placeholder={placeholder ?? 'Search...'}
      fullWidth
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      sx={{
        mb: 0
      }}
      slotProps={{
        input: {
          disableUnderline: true,
          startAdornment: (
            <InputAdornment position="start" sx={{ mt: '0 !important' }}>
              <SearchIcon color="action" />
            </InputAdornment>
          ),
          sx: {
            backgroundColor: '#e9e9ec',
            borderRadius: '8px',
            paddingLeft: '6px',
          },
        },
      }}
    />
  );
};

export default Searchbox;
